var exports = {
  "Aw": "listItem__97ykKy",
  "BB": "listItemCompact__wgJ6ti",
  "A5": "selectedRow__AOgEyu",
  "h_": "description__mZjLFE",
  "vF": "inlineChecksMainContent__kclwVu",
  "HB": "authorAssociationMainContent__fPQBaX",
  "jj": "authorAssociationDescription__zbGWHN",
  "zD": "titleLink__-u2mid",
  "r4": "filterLink__OXCGsP",
  "Qj": "assigneeFilterButton__jTgqFx",
  "j_": "linkedIssueLink__-cLCcl",
  "i8": "inlineChecksBadge__d-XZCQ",
  "TQ": "metadataGroup__7ts0Sx",
  "Ek": "timestampSeparator__CQkME0",
  "Fu": "alignedChecksBadge__YxdY5Y",
  "fk": "inlineSkeleton__X_zacc",
  "$D": "compactSkeletonSlot__R1zLXo",
  "FR": "loadingDescription__9EzKC8",
  "Fn": "loadingDescriptionSecondary__zP7fsj",
  "C4": "loadingDescriptionCompact__QmrO6O",
  "Jx": "taskListProgress__Mv0mzn",
  "QO": "inlineTaskListProgress___8U1To",
};

module.exports = exports;
